import React, { useState } from "react";
import {
  useStripe,
  useElements,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import "./StripePayment.css";
import { stripePaymentMethodHandler } from "./script";
import country from "../Signup/countries.json";
import { httpAdmin, httpPayments } from "../../Apis/commonApis";
import swal from "sweetalert";
import { useEffect } from "react";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";
import { ShowSwal } from "../../utils/alertSwal";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      lineHeight: "27px",
      color: "#212529",
      fontSize: "1.1rem",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
  // hidePostalCode: true
};

export default function CheckoutForm(props) {
  const {
    adminData,
    cartDetails,
    countryData,
    amount,
    setLast4,
    loading,
    setLoading,
    dataForNewSite,
    newCareSiteData,
    setBillingData,
  } = props;

  const location = useLocation();
  const {
    control,
    register,
    handleSubmit: handleSubmitForm,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
  } = useForm();

  const { taxesAddedCountryList, taxesAddedStateList } = useSelector(
    (state) => state.websitePlans
  );

  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (newCareSiteData?.isBilling && cartDetails !== 0) {
      setValue("billingAddress", newCareSiteData?.address);
      setValue("billingCity", newCareSiteData?.city);
      setValue("billingPostalCode", newCareSiteData?.postalCode);
      setValue("billingCountry", {
        label: newCareSiteData?.country,
        value: newCareSiteData?.countryId,
      });
      if (newCareSiteData?.state) {
        setValue("billingState", {
          label: newCareSiteData?.state,
          value: newCareSiteData?.stateId,
        });
      }
    } else if (adminData?.billingAddress && cartDetails !== 0) {
      const defaultAddress = adminData?.billingAddress;
      setValue("billingAddress", defaultAddress ?? "");

      setValue("billingCity", adminData?.city);
      setValue("billingPostalCode", adminData?.postalCode);
      const findBillingCountryObj = taxesAddedCountryList.find(
        (cItem) => cItem.label === adminData?.country
      );
      if (findBillingCountryObj) {
        setValue("billingCountry", findBillingCountryObj);
      }
      if (adminData?.state) {
        const findBillingStateObj = taxesAddedStateList.find(
          (cItem) => cItem.label === adminData?.state
        );
        if (findBillingStateObj) {
          setValue("billingState", findBillingStateObj);
        }
      }
    }
    if (adminData.billingAddressStatus && adminData?.email) {
      setValue("email", adminData.email);
    }
  }, [adminData, newCareSiteData, setValue]);

  const stripe = useStripe();
  const elements = useElements();

  const onSubmit = async (postdata) => {
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setBillingData(postdata);
    setLoading(true);
    setErrorMsg("");

    // Console log all form values
    // console.log("Form Values:", postdata);

    const paymentMethodObj = {
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: {
        name: postdata.name,
        email: postdata.email,
      },
    };

    const paymentMethodResult = await stripe.createPaymentMethod(
      paymentMethodObj
    );
    // console.log(paymentMethodResult, "paymentMethodResult");
    if (paymentMethodResult.error) {
      swal(
        "Error!",
        paymentMethodResult?.error?.message ?? "Something went wrong",
        "error"
      );
      // swal( paymentMethodResult.error, 'error');
      setLoading(false);
      return paymentMethodResult.error;
    } else {
      const last4Digit = paymentMethodResult?.paymentMethod?.card?.last4;
      setLast4(last4Digit);

      const subscriptionData = adminData?.subscriptionPlanData?.find(
        (item) => item._id === currentCareSiteId
      );
      if (
        cartDetails === 0 &&
        subscriptionData?.paymentThrough?.toLowerCase().includes("stripe")
      ) {
        changeStripeCard(
          paymentMethodResult.paymentMethod.id,
          subscriptionData?._id,
          last4Digit
        );
      } else {
        const newSiteDataUpdated = {
          ...dataForNewSite,
          bankNOorCardNo: last4Digit,
        };
        stripePaymentMethodHandler(
          {
            result: paymentMethodResult,
            amount: amount,
            cartDetails: cartDetails,
            adminData: adminData,
            countryData: countryData,
            newCareSiteData: newCareSiteData,
            dataForNewSite: newSiteDataUpdated,
            billingData: postdata,
          },
          handleResponse
        );
      }
    }
  };

  // callback method to handle the response
  const handleResponse = async (response) => {
    if (response.error) {
      setErrorMsg(response.error.message);
      return;
    }
    if (response.status) {
      const stripeSubData = await response;
      console.log(stripeSubData, "stripeSubData----");
      const confirm = await stripe.confirmCardPayment(
        stripeSubData?.clientSecret,
        {
          payment_method: { card: elements.getElement(CardNumberElement) },
        }
      );
      console.log(confirm, "confirm----");
      const { paymentIntent } = confirm; // if payment fails parameter name is payment_intent
      const idData = {
        subscriptionId: stripeSubData?.subscriptionId,
        customerId: stripeSubData?.customerId,
      };
      if (!paymentIntent && confirm.error) {
        ShowSwal(false, confirm.error?.message ?? "Something went wrong!");
        const deleteSubAndCust = await httpPayments(
          `deleteStripeCustomerAndSubscription`,
          idData
        );
        setLoading(false);
      } else {
        if (paymentIntent?.status === "succeeded") {
          props.setPaymentDetails(stripeSubData);
        } else if (paymentIntent) {
          props.setPaymentDetails(confirm);
        } else {
          ShowSwal(false, confirm.error?.message ?? "Something went wrong!");
          const deleteSubAndCust = await httpPayments(
            `deleteStripeCustomerAndSubscription`,
            idData
          );
          setLoading(false);
        }
      }
    } else {
      ShowSwal(false, response?.message ?? "Something went wrong!");
      setLoading(false);
      return;
    }
  };

  const changeStripeCard = async (paymentId, csid, last4Digit) => {
    let body = {
      careHomeId: csid,
      adminId: adminData._id,
      newPaymentThrough: "stripe",
      paymentMethodId: paymentId,
      newSubscriptionDetails: {
        bankNOorCardNo: last4Digit,
      },
    };
    const res = await httpAdmin("changeBillingMethod", "post", body, null);
    if (res?.status) {
      props.setPaymentDetails({ msg: res.message });
    } else {
      props.setPaymentDetails({ error: { message: res.message } });
    }
  };

  return (
    <React.Fragment>
      <h4 className="d-flex justify-content-between align-items-center mb-3">
        <span className="text-muted">Pay with card</span>
      </h4>
      <form onSubmit={handleSubmitForm(onSubmit)}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="cc-name">Name on card</label>
            <input
              id="cc-name"
              type="text"
              className="form-control"
              {...register("name", {
                required: "Name is required",
                minLength: {
                  value: 2,
                  message: "Name must be at least 2 characters",
                },
              })}
            />
            {errors?.name && (
              <p className="error_style error_bottom mt-1">
                {errors.name.message}
              </p>
            )}
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="cc-email">Email</label>
            <input
              id="cc-email"
              type="email"
              className="form-control"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              })}
              disabled={adminData && adminData.billingAddressStatus}
            />
            {errors?.email && (
              <p className="error_style error_bottom mt-1">
                {errors.email.message}
              </p>
            )}
          </div>

          {cartDetails !== 0 && (
            <>
              <div className="col-md-6 mb-3">
                <label htmlFor="cc-name">Billing Address</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Billing Address"
                  {...register("billingAddress", {
                    required: "Billing address is required",
                    minLength: {
                      value: 5,
                      message: "Address must be at least 5 characters",
                    },
                  })}
                />
                {errors?.billingAddress && (
                  <p className="error_style error_bottom mt-1">
                    {errors.billingAddress.message}
                  </p>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="cc-name">City</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter City"
                  {...register("billingCity", {
                    required: "City is required",
                    minLength: {
                      value: 2,
                      message: "City must be at least 2 characters",
                    },
                  })}
                />
                {errors?.billingCity && (
                  <p className="error_style error_bottom mt-1">
                    {errors.billingCity.message}
                  </p>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="billingCountry">Country</label>
                <Controller
                  name="billingCountry"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field }) => (
                    <div>
                      <Select
                        {...field}
                        className="select_Box_border"
                        placeholder="Select Country"
                        options={taxesAddedCountryList}
                        value={field.value}
                        onChange={(val) => field.onChange(val)}
                        onBlur={field.onBlur}
                        isClearable
                      />
                      {errors?.billingCountry && (
                        <p className="error_style error_bottom mt-1">
                          {errors.billingCountry.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
              {watch("billingCountry", "")?.label === "United States" && (
                <div className="col-md-6 mb-3">
                  <label htmlFor="billingState">State</label>
                  <Controller
                    name="billingState"
                    control={control}
                    rules={{
                      required:
                        watch("billingCountry", "")?.label === "United States"
                          ? "State is required"
                          : false,
                    }}
                    render={({ field }) => (
                      <div>
                        <Select
                          {...field}
                          className="select_Box_border"
                          placeholder="Select State"
                          options={taxesAddedStateList}
                          value={field.value}
                          onChange={(val) => field.onChange(val)}
                          onBlur={field.onBlur}
                          isClearable
                        />
                        {errors?.billingState && (
                          <p className="error_style error_bottom mt-1">
                            {errors.billingState.message}
                          </p>
                        )}
                      </div>
                    )}
                  />
                </div>
              )}
              <div className="col-md-6 mb-3">
                <label htmlFor="billingPostalCode">Postal Code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Postal Code"
                  {...register("billingPostalCode", {
                    required: "Postal code is required",
                  })}
                />
                {errors?.billingPostalCode && (
                  <p className="error_style error_bottom mt-1">
                    {errors.billingPostalCode.message}
                  </p>
                )}
              </div>
            </>
          )}

          <div className="col-md-12 mb-3">
            <label htmlFor="cc-number">Card Number</label>
            <CardNumberElement
              id="cc-number"
              className="form-control"
              options={CARD_ELEMENT_OPTIONS}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="expiry">Expiration Date</label>
            <CardExpiryElement
              id="expiry"
              className="form-control"
              options={CARD_ELEMENT_OPTIONS}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label htmlFor="cvc">CVC</label>
            <CardCvcElement
              id="cvc"
              className="form-control"
              options={CARD_ELEMENT_OPTIONS}
            />
          </div>
        </div>

        <hr className="mb-4" />
        <button className="btn card-btn w-100" type="submit" disabled={loading}>
          {loading ? (
            <div
              className="spinner-border spinner-border-sm text-light"
              role="status"
            ></div>
          ) : (
            `${
              amount
                ? `PAY ${
                    cartDetails ? cartDetails?.selectedCurrency?.symbol : ""
                  } ${amount}`
                : amount === 0
                ? "Add Payment Method"
                : "Change/Update Billing Method"
            }`
          )}
        </button>
        {errorMsg && <div className="text-danger mt-2">{errorMsg}</div>}
      </form>
    </React.Fragment>
  );
}
